module.exports = __webpack_public_path__ + "static/media/emojis2_04.ffabf69c.svg";